import TabOptions from '../options';

export class Model {
  acceptedTermsResponsibilities = false;
  signatureMechanismId = null;
  evaluatorName = null;
  evaluatorInitialName = null;
  evaluatorLastName = null;
  evaluatorSecondLastName = null;
  evaluatorDate = null;
  signedDocumentId = null;
  signedDocumentName = null;
}
export class Tab {
  id = 'Signature';
  title = 'Firma';
  model = new Model();
  valid = true;
  options = new TabOptions(new Model());
  build = (model) => {
    return {
      tab: this.id,
      ...model,
    };
  };
}
export default new Tab();
